import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "status-changes"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "status-changes__title" }, "Измененния статусов", -1)
const _hoisted_3 = { class: "status-changes__row" }
const _hoisted_4 = { style: {"min-width":"5rem"} }
const _hoisted_5 = { class: "status-changes__status" }
const _hoisted_6 = ["title"]

import EnumJobContainerStatus from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/database/enums/EnumJobContainerStatus";
import EnumJobStatus from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/database/enums/EnumJobStatus";
import ContainerStatusHistoryItem from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/containers/ContainerStatusHistoryItem";
import JobStatusHistoryItem from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/jobs/histories/status/JobStatusHistoryItem";
import EnumCodeTestStatus from "@/api/TestManager/dataSource/api/test-manager/data/entities/EnumCodeTestStatus";
import { ScheduleStatus } from "@/pages/_uc/schedule-status";
import ContainerStatus from "@/pages/_uc/schedule-status/container-status.vue";
import moment from "moment";
import { TirPmScrollbar } from "tir-components";
import { ref, computed, onMounted, watch } from "vue";

// Определение пропсов компонента

export default /*#__PURE__*/_defineComponent({
  __name: 'status-changes',
  props: {
  items: { type: Array<JobStatusHistoryItem | ContainerStatusHistoryItem> },
},
  emits: ["clickLogout", "update:message"],
  setup(__props, { emit: emits }) {

const props = __props;

// Импорты из Vue 3 Composition API


const isContainer = ref(true);
// Определение эмиттеров событий компонента


return (_ctx: any,_cache: any) => {
  return (__props.items.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(TirPmScrollbar), {
          "show-on-hover": true,
          style: { 'max-height': '15rem' }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items as any, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", null, _toDisplayString(_unref(moment)(item.Job?.DateCreated || item.Container?.DateCreated).format(
              "DD.MM.YYYY HH:mm:ss"
            )), 1),
                _createElementVNode("div", _hoisted_4, " [" + _toDisplayString(item.Type == 1 ? "Container" : "Job") + "] ", 1),
                _createElementVNode("div", _hoisted_5, [
                  (item.Type == 1)
                    ? (_openBlock(), _createBlock(ContainerStatus, {
                        key: 0,
                        "type-name": item.Job?.Status || item.Container?.Status,
                        "is-full-size": true
                      }, null, 8, ["type-name"]))
                    : (_openBlock(), _createBlock(_unref(ScheduleStatus), {
                        key: 1,
                        "type-name": item.Job?.Status || item.Container?.Status,
                        "is-full-size": true
                      }, null, 8, ["type-name"]))
                ]),
                _createElementVNode("div", {
                  class: "status-changes__message",
                  title: item?.Job?.Message || item?.Container?.Message
                }, _toDisplayString(item?.Job?.Message || item?.Container?.Message), 9, _hoisted_6)
              ]))
            }), 256))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})